import OrderChangeRequested from '../../../../application/order/events/OrderChangeRequested';
import OrderValidationResult from '../OrderValidationResult';
import { roundValueToMaxPackageSize } from '../../../roundValueToPackageSize';
import StockError from '../error';

export default (event: OrderChangeRequested): OrderValidationResult => {
    const validValue = roundValueToMaxPackageSize(event.value, event.product.packageSize);
    return {
        notification: validValue === event.value ? StockError.Null : StockError.ValueIsNotRounded,
        value: validValue
    };
};



// WEBPACK FOOTER //
// ./src/domain/orders/validators/common/roundOrderValue.ts